module.exports = __webpack_public_path__ + "static/img/semi-heavy-horse-blue.ed5e1cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/semi-heavy-horse-blue.svg
// module id = U9wb
// module chunks = 74